import AllForm from '../../Stateless/Form';
import { Box, Button, CircularProgress } from '@mui/material';
import { COLORS } from '../../../theme/themeConstants';
import { useThemeColors } from '../../../hooks/useThemeColors';
import { useCreateFaq, useEditFaqs } from '../../Query/FaqQuery';
import { useAtom } from 'jotai';
import { deliveryManagerAtom } from './FaqTable';
import { createFaqValidationSchema } from '../../HelperFunctions/validationUtils';

interface FaqFormValues {
  id?: string;
  question: string;
  questionInArabic: string;
  answer: string;
  answerInArabic: string;
}

const validationSchema = createFaqValidationSchema();

const AddFaqs = ({ onCancel }: { onCancel: () => void }) => {
  const [faqData] = useAtom(deliveryManagerAtom);
  // const [isFormChanged, setIsFormChanged] = useState(false);
  const { warning } = useThemeColors();

  // useEffect(() => {
  //   if (faqData) {
  //     setIsFormChanged(false);
  //   }
  // }, [faqData]);

  const { mutate: CreateFaq, isPending: CreateFaqLoading } = useCreateFaq();

  const { mutate: editFaqData, isPending: editFaqDataLoading } = useEditFaqs();
  return (
    <>
      {AllForm({
        initialValues: {
          question: faqData?.question || '',
          questionInArabic: faqData?.questionInArabic || '',
          answer: faqData?.answer || '',
          answerInArabic: faqData?.answerInArabic || '',
        },
        validationSchema,
        onSubmit: async (values: Record<string, any>) => {
          const modifiedValues: FaqFormValues = {
            question: values.question,
            questionInArabic: values.questionInArabic,
            answer: values.answer,
            answerInArabic: values.answerInArabic,
          };
          try {
            if (faqData?.id) {
              editFaqData(
                {
                  id: faqData.id,
                  data: modifiedValues,
                },
                {
                  onSuccess: () => {
                    onCancel();
                  },
                  onError: (error: any) => {
                    console.log(error);
                  },
                }
              );
            } else {
              CreateFaq(modifiedValues, {
                onSuccess: () => {
                  onCancel();
                },
                onError: (error: any) => {
                  console.error(error);
                },
              });
            }
          } catch (error) {
            console.error('Error submitting form:', error);
            // Optionally, you can show an error message to the user
          }
        },
        fields: [
          {
            name: 'question',
            label: 'Question:',
            type: 'text',
            isRequired: true,
          },
          {
            name: 'questionInArabic',
            label: 'Question (In Arabic):',
            type: 'text',
            isRequired: true,
          },
          {
            name: 'answer',
            label: 'Answer:',
            type: 'richtext',
            isRequired: true,
          },
          {
            name: 'answerInArabic',
            label: 'Answer (In Arabic):',
            type: 'richtext',
            isRequired: true,
          },
        ],
        customButton: (formikProps: any) => (
          <Box sx={{ display: 'flex', gap: 2, px: 2 }}>
            <Button
              type="submit"
              variant="contained"
              sx={{
                textTransform: 'none',
                fontSize: 14,
                px: 3,
                py: 1,
                backgroundColor: COLORS.primary.main,
                '&:hover': {
                  backgroundColor: COLORS.primary.dark,
                },
                '&:disabled': {
                  backgroundColor: 'rgba(0, 0, 0, 0.12)',
                  color: 'rgba(0, 0, 0, 0.26)',
                },
              }}
              onClick={(e) => {
                e.preventDefault();
                // Mark all fields as touched to show validation errors
                Object.keys(formikProps.values).forEach((fieldName) => {
                  formikProps.setFieldTouched(fieldName, true, false);
                });
                // Check if there are validation errors
                if (Object.keys(formikProps.errors).length === 0) {
                  formikProps.handleSubmit();
                } else {
                  // setIsFormChanged(true);
                  console.log('Validation failed:', formikProps.errors);
                }
              }}
              disabled={CreateFaqLoading || editFaqDataLoading}
              // disabled={Boolean(
              //   CreateFaqLoading ||
              //     editFaqDataLoading ||
              //     (faqData && !isFormChanged)
              // )}
            >
              {CreateFaqLoading || editFaqDataLoading ? (
                <>
                  <CircularProgress size={16} sx={{ color: '#fff', mr: 1 }} />
                  {faqData ? 'Updating...' : 'Creating...'}
                </>
              ) : faqData ? (
                'Update'
              ) : (
                'Create'
              )}
            </Button>
            <Button
              type="button"
              variant="outlined"
              color="error"
              onClick={onCancel}
              sx={{
                bgcolor: warning.main,
                color: '#fff',
                '&:hover': {
                  bgcolor: warning.dark,
                  color: '#fff',
                },
              }}
            >
              Cancel
            </Button>
          </Box>
        ),
      })()}
    </>
  );
};

export default AddFaqs;
